import React from "react"

import {useTranslation} from "react-i18next"
import SizePrice from "@bodeboca/algolia/components/wineblock/size-price"
import CommonUtils from "@bodeboca/utils"

type Props = {
  hit: any;
};

const PriceBoxRight = ({hit}: Props) => {
  const role = CommonUtils.getRole()
  const {t} = useTranslation()
  const pvp = role === "b2b" ? hit["cp_price"] : hit["pvp"]
  const showPvp = pvp > 0 && (hit["show_pvp"] || role === "b2b")
  const hasDiscount = hit["collection_discount_percentage"] > 0
  const discount = hit["collection_discount_percentage"]
  const hasVolumeDiscount = hit["volume_discount_qty"] > 0 && hit["volume_discount_amount"] > 0
  const stockForVolumeDiscount = hasVolumeDiscount && hit["stock_count"] >= hit["volume_discount_qty"]
  const lowStock = hit["stock_count"] > 0 && hit["stock_count"] < 6
  const stockCount = hit["stock_count"]
  const discountString = t("({{percent}}% off)", {'percent': discount})

  return (<div className="pricebox-part2">
    {/*IS VP CASE || SHOW PVP */}
    {showPvp && <div className="rrp">
      <SizePrice price={pvp} strikethrough={true}/>
    </div>}
    {/* HAS COLLECTION DISCOUNT */}
    {hasDiscount && <div className="ultimas-botellas-discount">
      <span className="text" title={discountString}>
        {discountString}
      </span>
    </div>}
    {/* HAS DISCOUNT AMOUNT */}
    {!hasDiscount && !showPvp && hasVolumeDiscount && stockForVolumeDiscount &&
      <div className="volume-discount">
        <span className="discount-multiplier">x{hit["volume_discount_qty"]}</span>
        <SizePrice
          price={hit["volume_discount_amount"]}
          strikethrough={false}/>
      </div>}
    {!hasDiscount && !showPvp && !hasVolumeDiscount && !stockForVolumeDiscount && lowStock &&
      <div className="volume-discount">
        <span className="ultimas-botellas">{t('only_units_left', {count: stockCount})}</span>
      </div>}
  </div>)
}
export default PriceBoxRight
